import * as React from 'react'

import styled from '../../theme/styled'
import {
  WorkspaceWindow,
  MainView,
  WorkspaceStatusBar
} from './WorkspaceStyles'
import TabView from '../Shared/TabView'
import Sidebar, { SidebarBody } from '../Shared/Sidebar'

import Calculation from './Calculation'
import InputCategories from './Calculation/InputCategories'
import PreViz from './PreViz'
import Progress from './Progress'

import EditorArea from './Calculation/EditorArea'
import ProjectToolbar from '../ProjectToolbar'
import NotificationPanel from './NotificationPanel'

// TODO: Set to true when there are advanced options to toolbar actions
const showInputToolbars = false

const Caret = require('../Shared/Sidebar/my_project_opencaret_down.svg')

const InputToolbar = styled.div`
  display: inline;
  overflow-y: auto;
  overflow-x: hidden;

  .input-toolbar-action {
    padding: 0 7px;
    float: right;
  }
`

const caseInputToolbar = (
  <InputToolbar>
    Show:
    <img
      className="input-toolbar-action"
      src={Caret}
      alt=""
      title="not yet available"
    />
    <div className="input-toolbar-action" title="not yet available">
      All
    </div>
  </InputToolbar>
)

const propertyInputToolbar = (
  <InputToolbar>
    Show:
    <img
      className="input-toolbar-action"
      src={Caret}
      alt=""
      title="not yet available"
    />
    <div className="input-toolbar-action" title="not yet available">
      Basic
    </div>
  </InputToolbar>
)

class Workspace extends React.Component {
  render() {
    return (
      <div
        style={{
          flex: '1 0 auto',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <ProjectToolbar />
        <NotificationPanel />
        <WorkspaceWindow key="workspacewin">
          <Sidebar
            title="Project Cases"
            toolbar={showInputToolbars ? caseInputToolbar : null}
          >
            <InputCategories />
          </Sidebar>
          <MainView>
            <TabView>
              <PreViz />
            </TabView>
          </MainView>
          <Sidebar
            title="Case properties"
            toolbar={showInputToolbars ? propertyInputToolbar : null}
          >
            <SidebarBody>
              <EditorArea />
              <hr className="full-width" />
            </SidebarBody>
          </Sidebar>
        </WorkspaceWindow>
        <WorkspaceStatusBar>
          <Progress />
          <div className="calc-button">
            <Calculation />
          </div>
        </WorkspaceStatusBar>
      </div>
    )
  }
}

export default Workspace



// WEBPACK FOOTER //
// ./src/Components/Workspace/index.tsx